import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class UpdateCollectiveAgreementCategoryDto {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  hourlyRate: number;

  @Expose()
  @Transform(({ value }) => toCents(value))
  extraHourlyRate: number;

  @Expose()
  @Transform(({ value }) => (value === null || value === undefined || value === "" ? null : toCents(value)))
  holidayHourlyRate?: number | null;
}
